import React from "react";
import type { Property } from "../PropiedadesPageNew";

interface PropertyActionModalProps {
    isOpen: boolean;
    selectedProp: Property | null;
    actionType: "status" | "delete" | "pending";
    isUpdating: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const PropertyActionModal: React.FC<PropertyActionModalProps> = ({
    isOpen,
    selectedProp,
    actionType,
    isUpdating,
    onClose,
    onConfirm
}) => {
    if (!isOpen || !selectedProp) return null;

    return (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
            <div className="bg-white border border-gray-200 rounded-xl p-7 w-[420px] max-w-[95vw] shadow-xl">
                <div 
                    className="w-[52px] h-[52px] rounded-xl mx-auto mb-4 flex items-center justify-center text-[26px]"
                    style={{
                        background: actionType === "pending" ? "rgba(245,158,11,0.12)" : selectedProp.status !== "SU" ? "rgba(248,113,113,0.12)" : "rgba(52,211,153,0.12)"
                    }}
                >
                    {actionType === "pending" ? "⏳" : selectedProp.status !== "SU" ? "🚫" : "✅"}
                </div>

                <h3 className="text-[17px] font-bold text-center mb-1 text-gray-900">
                    {actionType === "pending"
                        ? "Marcar como Pendiente"
                        : selectedProp.status !== "SU" ? "Suspender Propiedad" : "Reactivar Propiedad"}
                </h3>

                <p className="text-xs text-gray-500 text-center mb-5">
                    {actionType === "pending"
                        ? "¿Estás seguro de cambiar el estado a Pendiente? La propiedad requerirá revisión para volver a estar activa."
                        : selectedProp.status !== "SU"
                            ? "¿Estás seguro que deseas suspender esta propiedad? Dejará de estar visible para los huéspedes."
                            : "¿Confirmas que deseas volver a publicar esta propiedad en la plataforma?"}
                </p>

                <div className="flex gap-2">
                    <button
                        className="flex-1 py-2 rounded-lg text-xs font-semibold bg-white border border-gray-300 text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-colors shadow-sm"
                        onClick={onClose}
                        disabled={isUpdating}
                    >
                        Cancelar
                    </button>
                    <button
                        className="flex-1 py-2 rounded-lg text-xs font-semibold text-white border-none flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-sm"
                        style={{
                            background: actionType === "pending" ? "#f59e0b" : selectedProp.status !== "SU" ? "#ef4444" : "#10b981",
                            opacity: isUpdating ? 0.7 : 1
                        }}
                        onClick={onConfirm}
                        disabled={isUpdating}
                    >
                        {isUpdating ? "Procesando..." : "Confirmar"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PropertyActionModal;